//choose the color of the speaker, something nice, bright and outstanding, please choose not rgb please choose static color like red orange

export const speakerStyles = [
  {
    color: "red",
  },
  {
    color: "orange",
  },
  {
    color: "yellow",
  },
  {
    color: "green",
  },
  {
    color: "blue",
  },
  {
    color: "purple",
  },
  {
    color: "pink",
  },
  {
    color: "brown",
  },
  {
    color: "black",
  },
  {
    color: "white",
  },
  {
    color: "gray",
  },
  {
    color: "cyan",
  },
  {
    color: "magenta",
  },
  {
    color: "lime",
  },
  {
    color: "teal",
  },
  {
    color: "lavender",
  },
  {
    color: "maroon",
  },
  {
    color: "navy",
  },
  {
    color: "olive",
  },
  {
    color: "silver",
  },
  {
    color: "lime",
  },
  {
    color: "aqua",
  },
  {
    color: "fuchsia",
  },
  {
    color: "maroon",
  },
  {
    color: "navy",
  },
  {
    color: "olive",
  },
  {
    color: "silver",
  },
  {
    color: "lime",
  },
  {
    color: "aqua",
  },
  {
    color: "fuchsia",
  },
  {
    color: "maroon",
  },
  {
    color: "navy",
  },
  {
    color: "olive",
  },
  {
    color: "silver",
  },
  {
    color: "lime",
  },
  {
    color: "aqua",
  },
  {
    color: "fuchsia",
  },
  {
    color: "maroon",
  },
  {
    color: "navy",
  },
  {
    color: "olive",
  },
  {
    color: "silver",
  },
  {
    color: "lime",
  },
  {
    color: "aqua",
  },
  {
    color: "fuchsia",
  },
  {
    color: "maroon",
  },
  {
    color: "navy",
  },
  {
    color: "olive",
  },
  {
    color: "silver",
  },
  {
    color: "lime",
  },
  {
    color: "aqua",
  },
  {
    color: "fuchsia",
  },
  {
    color: "maroon",
  },
  {
    color: "navy",
  },
];
